import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ModerationOverridesQueryVariables = Types.Exact<{
  surface?: Types.InputMaybe<Types.ModerationSurface>
  direction?: Types.InputMaybe<Types.ModerationOverrideDirection>
  category?: Types.InputMaybe<Types.ModerationCategory>
  since?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type ModerationOverridesQuery = {
  __typename?: 'Query'
  moderationOverrides: {
    __typename?: 'ModerationOverrideConnection'
    total: number
    limit: number
    offset: number
    facets: Array<{
      __typename?: 'ModerationOverrideFacet'
      category: Types.ModerationCategory
      flagged: number
      overturned: number
      upheld: number
      missed: number
    }>
    items: Array<{
      __typename?: 'ModerationOverride'
      id: string
      aiEventId: string
      itemId: string
      authorUid: number
      direction: Types.ModerationOverrideDirection
      aiStatus: Types.CommentStatus
      aiCategory: Types.ModerationCategory
      aiTopScore?: number | null
      aiReason?: string | null
      aiDecidedAt: any
      humanStatus: Types.CommentStatus
      humanAction?: string | null
      actorUid?: number | null
      decidedAt: any
      textChanged: boolean
      actor?: { __typename?: 'UserInfoPublic'; uuid: string; username?: string | null } | null
      comment?: {
        __typename?: 'Comment'
        id?: string | null
        comment?: string | null
        subject?: string | null
        status?: Types.CommentStatus | null
        contentId?: number | null
        content?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          path?: string | null
        } | null> | null
        userInfo?: { __typename?: 'UserInfoPublic'; uuid: string; username?: string | null } | null
      } | null
    }>
  }
}

export const ModerationOverridesDocument = gql`
  query ModerationOverrides(
    $surface: ModerationSurface = COMMENT
    $direction: ModerationOverrideDirection
    $category: ModerationCategory
    $since: DateTime
    $limit: Int = 50
    $offset: Int = 0
  ) {
    moderationOverrides(
      surface: $surface
      direction: $direction
      category: $category
      since: $since
      limit: $limit
      offset: $offset
    ) {
      total
      limit
      offset
      facets {
        category
        flagged
        overturned
        upheld
        missed
      }
      items {
        id
        aiEventId
        itemId
        authorUid
        direction
        aiStatus
        aiCategory
        aiTopScore
        aiReason
        aiDecidedAt
        humanStatus
        humanAction
        actorUid
        decidedAt
        textChanged
        actor {
          uuid
          username
        }
        comment {
          id
          comment
          subject
          status
          contentId
          content {
            id
            contentId
            contentType
            title
            path
          }
          userInfo {
            uuid
            username
          }
        }
      }
    }
  }
`

/**
 * __useModerationOverridesQuery__
 *
 * To run a query within a React component, call `useModerationOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationOverridesQuery({
 *   variables: {
 *      surface: // value for 'surface'
 *      direction: // value for 'direction'
 *      category: // value for 'category'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useModerationOverridesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ModerationOverridesQuery,
    ModerationOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ModerationOverridesQuery, ModerationOverridesQueryVariables>(
    ModerationOverridesDocument,
    options,
  )
}
export function useModerationOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModerationOverridesQuery,
    ModerationOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ModerationOverridesQuery, ModerationOverridesQueryVariables>(
    ModerationOverridesDocument,
    options,
  )
}
// @ts-ignore
export function useModerationOverridesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModerationOverridesQuery,
    ModerationOverridesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ModerationOverridesQuery, ModerationOverridesQueryVariables>
export function useModerationOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ModerationOverridesQuery, ModerationOverridesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ModerationOverridesQuery | undefined,
  ModerationOverridesQueryVariables
>
export function useModerationOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ModerationOverridesQuery, ModerationOverridesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ModerationOverridesQuery, ModerationOverridesQueryVariables>(
    ModerationOverridesDocument,
    options,
  )
}
export type ModerationOverridesQueryHookResult = ReturnType<typeof useModerationOverridesQuery>
export type ModerationOverridesLazyQueryHookResult = ReturnType<
  typeof useModerationOverridesLazyQuery
>
export type ModerationOverridesSuspenseQueryHookResult = ReturnType<
  typeof useModerationOverridesSuspenseQuery
>
export type ModerationOverridesQueryResult = Apollo.QueryResult<
  ModerationOverridesQuery,
  ModerationOverridesQueryVariables
>
